import { Swiper } from 'swiper/bundle';

var consumablesSlider = document.getElementById('sliderConsumables');

if (consumablesSlider) {
  initializeSwiper(consumablesSlider);
}

function initializeSwiper(swiperInstance) {
  new Swiper(swiperInstance, {
    speed: 500,
    slidesPerView: 4,
    simulateTouch: false,
    navigation: {
      nextEl: swiperInstance.querySelector('.slider-control-next'),
      prevEl: swiperInstance.querySelector('.slider-control-prev'),
      disabledClass: 'slider-control-disabled',
    },
    pagination: {
      progressbarFillClass: 'slider-pagination-progressbar-fill',
      el: swiperInstance.querySelector('.slider-pagination-progressbar'),
      type: 'progressbar',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    slideActiveClass: 'slider-item-active',
  });
}

export { initializeSwiper };
